import gql from 'graphql-tag'

export const CREATE_GROUP = gql`
    mutation ($input: CreateGroupInput!) {
        createGroup(input: $input) {
            id
            name
            platform
            type
            isWhatsapp
            numberEvents
            contacts {
                id
                name
                lastName
                motherLastName
                email
                phone
                status
                area
            }
        }
    }
`
